<template>
  <div class="layout-container grid h-screen w-screen">
    <div class="lg:grid grid-cols-11">
      <div
        class="hidden lg:flex lg:col-span-3 xl:col-span-2 3xl:col-span-1 bg-slate-900 border-b border-slate-700 items-center"
      >
        <router-link to="/" class="flex items-center justify-start px-2 text-white">
          <vue-feather type="chevron-left" class="h-8" />
          <span class="text-sm font-semibold">Dashboard</span>
        </router-link>
      </div>
      <div
        class="z-10 py-3 w-full fixed lg:py-0 lg:static lg:col-span-8 xl:col-span-9 3xl:col-span-10 bg-slate-100 flex items-center justify-between px-8"
      >
        <div class="block lg:hidden text-left">
          <button
            class="-ml-0.5 -mt-0.5 h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:bg-gray-200 transition ease-in-out duration-150"
            aria-label="Open sidebar"
            @click="$refs.mobileMenu.showSidebar()"
          >
            <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
        <header class="text-lg font-bold">{{ lecture.name }}</header>
      </div>
    </div>
    <div class="lg:grid grid-cols-11">
      <div class="hidden lg:flex lg:col-span-3 xl:col-span-2 3xl:col-span-1 bg-slate-900 flex-col overflow-y-auto">
        <div class="text-white flex flex-grow flex-col justify-between">
          <div class="py-4 px-4 mt-4">
            <div v-for="courseSection in course.course_sections" :key="courseSection.id" class="mb-12">
              <header class="text-white font-bold mb-1">{{ courseSection.name }}</header>
              <router-link
                v-for="lecture in courseSection.lectures"
                :key="`course.${course.id}.lectures.${lecture.id}`"
                :to="`/agents/university/courses/${course.id}/lectures/${lecture.id}`"
                class="flex items-center text-slate-300 hover:text-white px-2 py-2 rounded-lg text-sm"
                :class="{ 'active-lecture-link': parseInt($route.params.id) === lecture.id }"
              >
                {{ lecture.name }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="lg:col-span-8 xl:col-span-9 3xl:col-span-10 flex flex-col overflow-y-scroll">
        <div class="flex-grow p-8">
          <slot></slot>
        </div>
      </div>
    </div>

    <Alert ref="alert" />
  </div>
</template>

<script>
import Alert from '../shared/Alert.vue';

export default {
  name: 'SettingsPageLayout',
  components: {
    Alert,
  },
  props: {
    course: {
      type: Object,
      required: true,
    },
    lecture: {
      type: Object,
      required: true,
    },
    courseSection: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      sidebar: true,
    };
  },
  computed: {
    routeHeader() {
      let header = '';
      if (this.$route.name.includes('Detail')) {
        header = this.$route.name.replace('Detail', '');
      } else if (this.$route.name.includes('New')) {
        header = this.$route.name.replace('New', '');
      } else if (this.$route.name.includes('Edit')) {
        header = this.$route.name.replace('Edit', '');
      } else if (this.$route.name.includes('Calendar')) {
        header = this.$route.name.replace('Calendar', '');
      } else {
        header = this.$route.name;
      }
      return header;
    },
  },
  async mounted() {
    document.body.classList.add('lg:overflow-hidden');
    await this.$store.dispatch('general/loadCurrentUserAccountDetails');

    // const activeLecture = document.getElementsByClassName('active-lecture-link')

    // if(element) {
    //   const activeLectureElement = activeLecture[0]

    //   const offset = activeLectureElement.offset.top

    //   document.scrollTo(offset)
    // }
  },
  methods: {
    showHelp() {
      return ![
        'Dashboard',
        'Dashboard V2',
        'Settings',
        'Integrations',
        'CandidateNew',
        'CandidateEdit',
        'Scorecard',
      ].includes(this.$route.name);
    },
  },
};
</script>

<style>
@reference "tailwindcss";
.layout-container {
  grid-template-rows: 70px calc(100vh - 70px);
}

.active-lecture-link {
  @apply bg-slate-800;
}
</style>
